// extracted by mini-css-extract-plugin
export default {"card":"styles_card__n3aiS","header":"styles_header__O3LbS","status":"styles_status__qzK7k","content":"styles_content__4qfGq","row":"styles_row__4e-6d"};